import { useMutation } from "@tanstack/react-query";

import { publishJobWithRethrow } from "src/api/projects";

export const usePublishJob = () => {
  return useMutation({
    mutationFn: (jobId: string) => publishJobWithRethrow(jobId)
  });
};
